import * as React from 'react';
import styled from 'styled-components';
import { Link } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { LG, MD, SM } from '@origin-digital/helper';
import CardBlock from './CardBlock';
import Title from './Title';
import { WhyOriginDefaultProps, WhyOriginProps } from './WhyOrigin.types';

export const FlexContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 100%;

  ${SM`
    flex-flow: row;
  `}

  & > * {
    flex: 1;
    margin-bottom: 32px;

    ${SM`
      margin-bottom: 0;
      &:not(:last-child) {
        margin-right: 8px;
      }
    `}

    ${MD`
      &:not(:last-child) {
        margin-right: 16px;
      }
    `}

    ${LG`
      &:not(:last-child) {
        margin-right: 32px;
      }
    `}
  }
`;

const UnstyledLink = styled(Link)`
  text-decoration: none;
`;

export const WhyOrigin: React.FunctionComponent<WhyOriginProps> = ({ headline, items, color }) => (
  <Box color={color}>
    <Title title={headline || ''} />
    <FlexContainer>
      {(items || [])
        .filter(({ headline }) => headline != null && headline.length)
        .map((card, index) => {
          const cardBlock = (
            <CardBlock
              key={card.headline}
              title={card.headline}
              content={card.bylineHtml}
              iconSvg={card.iconSvg}
              delay={index === 0 ? 400 : 400 + index * 200}
            />
          );

          return card.href ? (
            <UnstyledLink
              href={card.href}
              key={card.headline}
              data-id={card['data-id']}
              target={card.newTab ? '_blank' : '_self'}
              componentType="CardBlock"
            >
              {cardBlock}
            </UnstyledLink>
          ) : (
            cardBlock
          );
        })}
    </FlexContainer>
  </Box>
);

// WhyOrigin.propTypes = WhyOriginPropsType;
WhyOrigin.defaultProps = WhyOriginDefaultProps;
